import { Option } from '@fluentui/react-components';
import { Dismiss20Regular } from '@fluentui/react-icons';
import React from 'react';

import { Button } from '../Button/Button';
import { Dropdown } from '../Dropdown/Dropdown';
import { Text } from '../Text/Text';
import { DataListProps, FilterProps } from './Table.interface';
import styles from './Table.module.css';
import { useTranslation } from 'react-i18next';

const getDropdownValues = (data: DataListProps[], columnKey: string) => {
  return data
    .map(
      ({ items }) =>
        typeof items.find(({ key }) => key === columnKey)?.searchkey ===
          'string' && items.find(({ key }) => key === columnKey)?.searchkey,
    )
    .filter((value, index, self) => self.indexOf(value) === index);
};

const Filter: React.FC<FilterProps> = ({
  columns,
  data,
  onClose,
  onTableFilterValues,
  filterValues,
  reset,
}) => {
  const { t } = useTranslation();
  const allLabel = t('tableFilter_all', { defaultValue: 'Alle' });

  return (
    <>
      <div className="flex justify-between">
        <div className="flex gap-4">
          <Text title="Table-Filters">
            {t('tableFilter_filters', { defaultValue: 'Filter' })}
          </Text>
          <Button
            size="small"
            title="reset-table"
            onClick={reset}
            data-cy="reset-table"
          >
            {t('tableFilter_reset', { defaultValue: 'Zurücksetzen' })}
          </Button>
        </div>
        <Button
          shape="circular"
          icon={<Dismiss20Regular />}
          title="close"
          size="small"
          onClick={onClose}
          aria-label={t('close', { defaultValue: 'Schließen' })}
        />
      </div>
      <div className={styles.dropdownFlex}>
        {columns.items
          .filter(({ filter }) => filter)
          .map(({ content, uniqueKey }) => (
            <div key={uniqueKey}>
              <Text>{content}</Text>
              <Dropdown
                value={filterValues[uniqueKey] || allLabel}
                selectedOptions={[filterValues[uniqueKey] || allLabel]}
                aria-labelledby={uniqueKey}
                title={`filter-${uniqueKey}`}
                className={styles.dropdown}
                onOptionSelect={(_, data) => {
                  onTableFilterValues({
                    [uniqueKey as string]: data.optionValue as string,
                  });
                }}
              >
                {[allLabel, ...getDropdownValues(data, uniqueKey)]
                  .filter(Boolean)
                  .map(value => (
                    <Option key={String(value)} value={String(value)}>
                      {String(value)}
                    </Option>
                  ))}
              </Dropdown>
            </div>
          ))}
      </div>
    </>
  );
};

export default Filter;
